import colors from 'assets/theme/base/colors';

const formLabel = {
    styleOverrides: {
        root: {
            '&.Mui-disabled': {
                color: colors.divider,
            },
        },
    },
};

export default formLabel;
